import { LoanApplicationTabName, LoanApplicationTabRouteParam } from 'constants/loanApplication';
import { StatusEnum } from 'constants/status';

export const LOAN_EDITOR_ACTION_SECTION_NAME = 'Loan Editor Action';

export const ADD_NEW_MORTGAGE = 'ADD_NEW_MORTGAGE';

// Important! Do not change values (id) in LoanApplicationTabId enum for compatibility reason.
export const LoanApplicationTabId = {
  LOAN: 0,
  PERSONAL_INFORMATION: 1,
  ADDRESS: 2,
  PROPERTY: 3,
  REO: 4,
  INCOME_AND_EMPLOYMENT: 5,
  ASSETS: 6,
  LIABILITIES: 7,
  TRANSACTION: 8,
  DECLARATIONS: 9,
  LOCK_INFO: 10,
  LOAN_ORIGINATOR: 11,
  LOAN_FEES: 12,
  UNDERWRITING: 13,
  LEAD: 14,
  LOAN_ROLES: 15,
  LOAN_TAGS: 16,
  CLOSING: 17,
  CHECKLISTS: 18,
  KEY_DATES: 19,
};

export const LoanApplicationTabIdToName = {
  [LoanApplicationTabId.LOCK_INFO]: LoanApplicationTabName.LOCK_INFO,
  [LoanApplicationTabId.LOAN]: LoanApplicationTabName.LOAN,
  [LoanApplicationTabId.PERSONAL_INFORMATION]: LoanApplicationTabName.PERSONAL_INFORMATION,
  [LoanApplicationTabId.ADDRESS]: LoanApplicationTabName.ADDRESS,
  [LoanApplicationTabId.PROPERTY]: LoanApplicationTabName.PROPERTY,
  [LoanApplicationTabId.REO]: LoanApplicationTabName.REO,
  [LoanApplicationTabId.INCOME_AND_EMPLOYMENT]: LoanApplicationTabName.INCOME_AND_EMPLOYMENT,
  [LoanApplicationTabId.ASSETS]: LoanApplicationTabName.ASSETS,
  [LoanApplicationTabId.LIABILITIES]: LoanApplicationTabName.LIABILITIES,
  [LoanApplicationTabId.TRANSACTION]: LoanApplicationTabName.TRANSACTION,
  [LoanApplicationTabId.DECLARATIONS]: LoanApplicationTabName.DECLARATIONS,
  [LoanApplicationTabId.LOAN_ORIGINATOR]: LoanApplicationTabName.LOAN_ORIGINATOR,
  [LoanApplicationTabId.LOAN_FEES]: LoanApplicationTabName.LOAN_FEES,
  [LoanApplicationTabId.UNDERWRITING]: LoanApplicationTabName.UNDERWRITING,
  [LoanApplicationTabId.KEY_DATES]: LoanApplicationTabName.KEY_DATES,
  [LoanApplicationTabId.LEAD]: LoanApplicationTabName.LEAD,
  [LoanApplicationTabId.LOAN_ROLES]: LoanApplicationTabName.LOAN_ROLES,
  [LoanApplicationTabId.LOAN_TAGS]: LoanApplicationTabName.LOAN_TAGS,
  [LoanApplicationTabId.CLOSING]: LoanApplicationTabName.CLOSING,
  [LoanApplicationTabId.CHECKLISTS]: LoanApplicationTabName.CHECKLISTS,
};

export const LoanApplicationUrlSearchParams = {
  DOCUMENT_ID: 'documentId',
  DOCUMENT_TYPE_NAME: 'documentTypeName',
};

export const uncompletedLoanErrorMessageParams = {
  message:
    'The loan can be only edited after the borrower has entered the pre-qualification information.',
  variant: 'error',
};

export const ApplicationStatus = {
  INITIATED_BY_LEAD: 'InitiatedByLead',
  LOAN_CREATED: 'LoanCreated',
  FIRST_PART_INITIATED: 'FirstPartInitiated',
  FIRST_PART_SUBMITTED: 'FirstPartSubmitted',
  SECOND_PART_SUBMITTED: 'SecondPartSubmitted',
  SECOND_PART_COMPLETED: 'SecondPartCompleted',
  REGISTERED: 'Registered',
};

export const SeverityColorsType = {
  RED: 'red',
  YELLOW: 'yellow',
};

// HZ-3805: the checklist surface routes under ALERTS (both `<Alerts />` and the legacy `<Checklists />`),
// so CHECKLISTS never matched the active tab and a saved checklist override kept rendering its pre-save state.
export const loanTabsToUpdateOnSaveChanges = [
  LoanApplicationTabRouteParam.ALERTS,
  LoanApplicationTabRouteParam.LOAN_FEES,
];

export const loanSubtabsToUpdateOnSaveChanges = [
  LoanApplicationTabRouteParam.LOAN_ROLES,
  LoanApplicationTabRouteParam.LOAN_TAGS,
];

export const LEAD_STAGE_STATUSES = [
  ApplicationStatus.INITIATED_BY_LEAD,
  ApplicationStatus.FIRST_PART_INITIATED,
];

export const APPLICATION_COMPLETED_STATUSES = [
  ApplicationStatus.SECOND_PART_COMPLETED,
  ApplicationStatus.INITIATED_BY_LEAD,
  ApplicationStatus.REGISTERED,
];

export const tabsWithoutHorPadding = [
  LoanApplicationTabRouteParam.ACTIVITIES,
  LoanApplicationTabRouteParam.DOCUMENTS,
];

// The Tasks tab relied on its own internal table scroll fitting exactly within the viewport, which
// broke once `<PathToSubmission />` (DEV-4305) started rendering unconditionally above every tab's
// content — the extra banner height pushed the tab's total content past the viewport with no page-
// level scroll to reach it (DEV-5495). Every tab now uses the default page-level scroll.
export const tabsWithoutContentScroll = [];

export const headerOptions = {
  disablePaddings: true,
};

export const ZIP_MAX_LENGTH_INTERNATIONAL = 10;
export const ZIP_MAX_LENGTH_US = 5;

export const PERCENTAGE = 100;
export const YELLOW_SHADE_LIGHT = 800;
export const YELLOW_SHADE_DARK = 500;
export const COLOR_LIGHTEN_FACTOR = 0.02;
export const SPACING_LG = 24;
export const SPACING_SM = 8;
export const FORM_BUTTONS_TOP_OFFSET = -8;

export const PERCENT_MULTIPLIER = 100;
export const LEASE_RENT_RATIO = 0.75;
export const RETRY_MESSAGE_FALLBACK = 'We have encountered an error, please try again';

export const ChecklistStatusPriority = {
  [StatusEnum.ERROR]: 0,
  [StatusEnum.WARNING]: 1,
  [StatusEnum.SUCCESS]: 2,
  [StatusEnum.INFO]: 3,
};

export const DEFAULT_CHECKLIST_STATUS_PRIORITY = ChecklistStatusPriority.SUCCESS;

export const ChecklistSortField = {
  STATUS_PRIORITY: 'statusPriority',
  TAB_NAME: 'tabName',
};
